import Immutable from "immutable";
import queryString from "query-string";

const rootState = Immutable.Map({
  lastPageHistory: Immutable.Map({
    answers: null,
    questions: null,
    conversations: null,
    analytics: null,
    settings: null
  }),
  fullPaths: Immutable.Map()
});

export const root = (state = rootState, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      let newState = state;

      newState = newState.setIn([
        "lastPageHistory",
        action.rootPath
      ], action.url);

      // Set's key/value pairs like
      // "/analytics/overview" => "/analytics/overview?endDate=2019-08-09&startDate=2019-08-05"
      newState = newState.setIn([
        "fullPaths",
        queryString.parseUrl(action.url).url
      ], action.url);

      return newState;
    }

    default:
      return state;
  }
};
